import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { EMDMICONS } from '../../../../common/constants/icon-packs.constant';
import { HelpService } from '../../service/help.services';
import { FileNameTransformPipe } from '../../../../common/pipes/filename-transform.pipe';
import { CommonService } from '../../../../common/service/common.service';
import { FileSaverService } from 'ngx-filesaver';
import { NotificationService } from '@progress/kendo-angular-notification';
import { RelativeDatePipe } from '../../../../common/pipes/relative-date.pipe';

@Component({
  selector: 'app-help-item',
  standalone: false,
  templateUrl: './help-item.component.html',
  styleUrl: './help-item.component.scss'
})
export class HelpItemComponent {
  iconPacks = EMDMICONS;

  public myRestrictions: FileRestrictions = {
    allowedExtensions: ["jpg", "jpeg", "png"],
  };

  frmHelpItems!: FormGroup;
  tagsList: any = [];
  filterTagsList: any = [];
  helpItemsList: any = [];
  selectedFile: any = null;
  validFileType: boolean = true;
  fileName: string = 'Please choose a file.'
  filePipe = new FileNameTransformPipe();
  datePipe = new RelativeDatePipe();

  userId: any = sessionStorage.getItem('userId');

  constructor(private fb: FormBuilder,
    private helpService: HelpService,
    private fileSaverService: FileSaverService,
    private notificationService: NotificationService,
    private commonService: CommonService
  ) {

    this.getTags();
    this.getHelpItems();
  }

  ngOnInit() {
    this.bindFrmHelpItems();
  }


  triggerFileInput() {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }
  onFileSelect(event: any) {
    this.validFileType = true;
    const file = event.target.files[0];
    var allowedExtensions = /(\.pdf)$/i;

    if (file) {
      this.fileName = file.name;
      this.selectedFile = file;

      if (!allowedExtensions.exec(this.fileName)) {
        this.validFileType = false;
      }
    }

    if (event.target.files[0].name) {
      this.fileName = event.target.files[0].name
    }
  }
  bindFrmHelpItems() {

    this.frmHelpItems = this.fb.group({
      category: [null],
      file: [null, [Validators.required]],
      note: ['']
    });

    this.frmHelpItems.valueChanges.subscribe({
      next: (data: any) => {
        this.logValidationErrorHelpItems(this.frmHelpItems)
      },
      error: (err) => { }
    })
  }

  logValidationErrorHelpItems(group: FormGroup = this.frmHelpItems): void {
    Object.keys(group.contains).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrorHelpItems(abstractControl)
      } else {
        this.formErrorHelpItem[key] = '';
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const message: any = this.errorMessagesHelpItem[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrorHelpItem[key] += message[errorKey] + ' '
            }
          }
        }
      }

    })
  }

  formErrorHelpItem: any = {
    file: '',
  }
  errorMessagesHelpItem: any = {
    file: { 'required': '' }
  };
  markFormTouched(frmGroup: FormGroup) {
    (<any>Object).value(frmGroup.controls).forEach((control: any) => {
      if (control.controls) {
        this.markFormTouched(control)
      } else {
        control.markFormTouched()
      }
    })
  }

  onSubmit() {

    if (this.cRow) {
      this.updateHlepItem();
      return;
    }

    if (!this.frmHelpItems.value.category?.id) {
      this.commonService.showNotificationMessage('Please select a tag for your document.', 'error');
      return;
    }
    const formData = new FormData();
    formData.append('UserId', this.userId);
    formData.append('TagId', this.frmHelpItems.value.category.id);
    formData.append('Notes', this.frmHelpItems.value.note ?? '');
    formData.append('File', this.selectedFile);

    this.helpService.addHelpItems(formData).subscribe({
      next: data => {
        if (data.success) {
          this.getHelpItems();
          this.resetForm();
        } else {

        }
      },
      error: (err) => {
        let message: any = '';
        Object.keys(err.error.errors).forEach((key: string) => {
          message += err.error.errors[key];
        })
        if (message)
          this.commonService.showNotificationMessage(message, 'error');
        else
          console.error(err.error.errors || 'Error while adding help item.')
      }
    })
  }

  updateHlepItem() {

    const formData = new FormData();
    formData.append('documentId', this.cRow.documentId);
    formData.append('UserId', this.userId);
    formData.append('TagId', this.frmHelpItems.value.category.id || 0);
    formData.append('Notes', this.frmHelpItems.value.note);
    if (this.selectedFile)
      formData.append('File', this.selectedFile);

    this.helpService.updateHelpItems(formData, this.cRow.documentId).subscribe({
      next: data => {
        if (data) {
          this.commonService.showNotificationMessage(data, 'success');
          this.getHelpItems();
          this.resetForm();
          this.cRow = null;
        } else {

        }
      },
      error: (err) => {
        let message: any = '';
        Object.keys(err.error.errors).forEach((key: string) => {
          message += err.error.errors[key];
        })
        if (message)
          this.commonService.showNotificationMessage(message, 'error');
        else
          console.error(err.error.errors || 'Error while adding help item.')
      }
    })
  }

  cRow: any = null;
  editHelpItem(row: any) {
    this.cRow = row;
    this.fileName = row.fileName;

    let catg = this.filterTagsList.find((x: any) => x.tagName == row.tagName)
    this.frmHelpItems.patchValue({
      category: catg,
      note: row.notes
    });
  }
  resetForm() {
    this.frmHelpItems.reset({
      category: null,
      file: null,
      note: ''
    });
    this.selectedFile = null;
    this.fileName = 'Please choose a file.'
  }


  getTags() {
    this.helpService.getTags({}).subscribe({
      next: data => {
        this.filterTagsList = data
        this.tagsList = data
      },
      error: (err) => { }
    })
  }
  getHelpItems() {
    this.helpService.getHelpItems({}).subscribe({
      next: data => {
        this.helpItemsList = data
      },
      error: (err) => { }
    })
  }
  addHelpItems() {
    let body = {}
    this.helpService.addHelpItems(body).subscribe({
      next: data => {
        this.getHelpItems();

      },
      error: (err) => { }
    })
  }
  deleteHelpItem(helpItemDocumentId: number) {
    if (confirm('Do you want to delete this file?')) {
      this.helpService.deleteHelpItem(helpItemDocumentId).subscribe({
        next: data => {
          this.getHelpItems();
        },
        error: (err) => { }
      })
    }
  }

  getAttachments(object: any) {

    this.helpService.downloadAttachments(object.blobURI).subscribe({
      next: (fileData: any) => {
        let fileName = object.fileName;
        if (fileData) {
          this.fileSaverService.save(fileData, fileName);
        }
      },
      error: (err) => { }
    })
  }
  handleFilter(value: any) {
    this.filterTagsList = this.tagsList.filter(
      (s: any) => {
        return s.tagName.toLowerCase().indexOf(value.toLowerCase()) !== -1
      }
    );
  }
}
